
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import ChooseReason from "../ChoseReason";
import { REOPEN_WORKKARD_TITLE } from '../../containers/WorkkardDetail/constants';
import { showDialogueBox } from '../DialogueBox/actions';
import { postActivityMenuActions, clearCloseActivities } from '../../containers/WorkkardDetail/actions/action';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';

const ReopenWorkkard = (props) => {
    const dispatch = useDispatch();
    const workkard = useSelector(state => state.workkardDetail.workkardDetail);
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;

    React.useEffect(() => {
        return () => {
            dispatch(clearCloseActivities());
        };
    }, []);

    const closeDialogBox = () => {
        dispatch(showDialogueBox({
            flag: false,
            dialogueBoxComponent: null
        }));
    };

    const onConfirmClick = (data) => {
        dispatch(postActivityMenuActions(data));
        closeDialogBox();
    };

    return (
        <ChooseReason
            wkid={workkard.Id}
            title={REOPEN_WORKKARD_TITLE}
            uView={userView}
            onClose={closeDialogBox}
            onConfirmClick={(data) => onConfirmClick(data)}
            isReopenWorkkard={true}
            showNoteText={false}
        />
    );
};

export default ReopenWorkkard;
